export const SELECTED_SHIPPING_ADDRESS = 'SELECTED_SHIPPING_ADDRESS';
